<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="getServicesPromise" />
    <Placy
      v-if="!items || !items.length"
      :promise="getServicesPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('SERVICE', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('SERVICE', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="items && items.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          autocomplete="off"
          @focus="searchFocused = true"
          @blur="searchFocused = false"
        />
        <i class="search icon"></i>
      </div>
    </div>

    <template v-for="t in serviceTypes">
      <router-link
        class="header item"
        :key="t.name"
        :active-class="'active'"
        :to="{ name: 'new-service', params: { serviceType: t.name } }"
      >
        <i class="icon plus"></i>
        <strong>{{ $t('NEW', { thing: $tc(t.name + '_SERVICE', 1) }) }}</strong>
      </router-link>
      <router-link
        class="item"
        :active-class="'active'"
        :to="{
          name: 'service',
          params: { serviceType: service.original.serviceType, serviceId: service.original.id }
        }"
        v-for="service in filteredItems"
        :key="service.original.id"
        v-if="service.original.serviceType === t.name"
      >
        <div class="info">
          <div
            class="name ellipsis"
            :title="service.original.name || service.original.id"
            v-html="service.string"
          />
          <div class="service-type" v-if="service.original.serviceConfiguration.type">
            <i
              class="ui icon"
              :title="service.original.serviceConfiguration.type"
              :class="[service.original.serviceConfiguration.typeIcon]"
              v-if="service.original.serviceConfiguration.typeIcon"
            />
            <div class="ui mini basic label" v-else>
              {{ service.original.serviceConfiguration.type }}
            </div>
          </div>
        </div>
        <div class="key ellipsis" :title="service.original.key">
          {{ service.original.key || '-' }}
        </div>
      </router-link>
    </template>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav.ui.vertical.menu {
  overflow-y: scroll;
}

.name,
.key {
  padding: 5px;
}

.info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.key {
  color: gray;
}
</style>

<script>
// @flow
import _ from 'lodash'
import { Spinny, Placy } from 'ui'
import { Service } from 'services'
import FuzzyFilterer from '../Mixins/FuzzyFilterer'

export default {
  name: 'service-list',
  components: { Spinny, Placy },
  mixins: [FuzzyFilterer],

  props: ['serviceType'],

  data() {
    return {
      showMenu: false,
      getServicesPromise: null
    }
  },

  computed: {
    items() {
      return this.$store.state.service.items
    },
    serviceTypes() {
      return _.filter(Service.serviceTypes(), st => st.name === this.serviceType)
    }
  },
  created() {
    this.getServicesPromise = Service.readAllServices()
  }
}
</script>
